import React from 'react';
import { connect } from 'react-redux';

import SumsubWebSdk from '@sumsub/websdk-react';
import amplitude from 'amplitude-js';
import { toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { INCREASE_LIMITS_DOCUMENTS_SELECTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ID_DOCUMENT_TYPE, KYC_PROVIDER } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SUMSUB } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK, SUMSUB_FRAME_TOKEN } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { useAuth, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const SumsubFramePage = (props) => {
    const { lang } = useLanguage();
    const { phone } = useAuth();
    const { sumsubAccessToken, linkInProgress, linkSuccess, linkFail } = useExtra();
    const { documentSubmittedSpinner } = usePageMessages();

    const configs = {
        lang: lang,
        phone: phone,
    };

    const options = {
        addViewportTag: true,
        adaptIframeHeight: true,
    };

    const handleSumsubMessage = (type, payload) => {
        if (type === 'idCheck.onStepCompleted' && payload.idDocType) {
            amplitude.getInstance().logEvent(INCREASE_LIMITS_DOCUMENTS_SELECTED, {
                [KYC_PROVIDER]: SUMSUB,
                [ID_DOCUMENT_TYPE]: payload.idDocType,
            });
        }
        if (type === 'idCheck.onApplicantStatusChanged') {
            const result = payload?.reviewResult;
            const status = payload?.reviewStatus;
            if (status === 'pending') {
                props.toggleModalWithTimer(true, documentSubmittedSpinner, () => window.location.replace(linkInProgress));
            } else if (status === 'completed' && result) {
                if (result?.reviewAnswer === 'RED') {
                    if (result?.reviewRejectType === 'FINAL') {
                        props.toggleSpinner(true);
                        window.location.replace(linkFail);
                    }
                } else if (result?.reviewAnswer === 'GREEN') {
                    props.toggleSpinner(true);
                    window.location.replace(linkSuccess);
                }
            }
        }
    };

    const onError = () => {
        window.location.replace(linkFail);
    };

    const expirationHandler = async () => {
        apiFetchData(SUMSUB_FRAME_TOKEN)
            .then((json) => {
                if (json) {
                    if (json.extra) {
                        return json.extra.sumsubAccessToken;
                    }
                }
            })
            .catch((e) => {
                logInfo(e);
            });
    };

    return (
        <CommonPage leftCloseIcon backUrl={AUTH_SEND_MAIN_LINK} showChat={false}>
            {sumsubAccessToken && (
                <SumsubWebSdk
                    accessToken={sumsubAccessToken}
                    expirationHandler={expirationHandler}
                    config={configs}
                    options={options}
                    onMessage={handleSumsubMessage}
                    onError={onError}
                />
            )}
        </CommonPage>
    );
};

export default connect(null, { toggleModalWithTimer, toggleSpinner })(BasePage(SumsubFramePage));
